// Authentication Constants
export const AUTH_MODES = {
  LOGIN: 'login',
  REGISTER: 'register'
};

export const MOCK_CREDENTIALS = {
  login: {
    email: 'user@radiocoim.ru',
    password: 'radio123'
  },
  register: {
    username: 'newvoice',
    email: 'newuser@radiocoim.ru',
    password: 'radio123',
    confirmPassword: 'radio123',
    voiceDescription: 'Мой аутентичный голос'
  }
};

export const ERROR_MESSAGES = {
  REQUIRED_EMAIL: 'Введите email',
  INVALID_EMAIL: 'Неверный формат email',
  REQUIRED_PASSWORD: 'Введите пароль',
  PASSWORD_TOO_SHORT: 'Пароль должен содержать минимум 6 символов',
  REQUIRED_USERNAME: 'Введите имя пользователя',
  USERNAME_TOO_SHORT: 'Имя должно содержать минимум 3 символа',
  REQUIRED_VOICE_DESC: 'Опишите свой голос',
  PASSWORD_MISMATCH: 'Пароли не совпадают',
  REQUIRED_TERMS: 'Необходимо согласие с условиями',
  LOGIN_FAILED: 'Неверный email или пароль. Используйте:\nEmail: user@radiocoim.ru\nПароль: radio123'
};

export const STORAGE_KEYS = {
  IS_AUTHENTICATED: 'isAuthenticated',
  USER_EMAIL: 'userEmail',
  USERNAME: 'username',
  AUTH_PROVIDER: 'authProvider'
};

export const PLATFORM_FEATURES = [
  { icon: 'Mic', text: 'Прямые эфиры без задержек' },
  { icon: 'Users', text: 'Сообщество единомышленников' },
  { icon: 'Shield', text: 'Защита вашего контента' },
  { icon: 'Headphones', text: 'Качественный звук' }
];